module.exports = __webpack_public_path__ + "img/image_0_3.d229473a.jpg";